import { styled } from '@compiled/react';
import Button from '@atlaskit/button';
import { token } from '@atlaskit/tokens';

const CONTENT_OFFSET = token('space.100', '8px');

const WRAPPER_TRANSFORM = `translate(calc(-100% - ${CONTENT_OFFSET}), -50%)`;

// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled, @atlaskit/ui-styling-standard/no-exported-styles -- Ignored via go/DSP-18766
export const ExpandIconWrapper = styled(Button)({
	transform: WRAPPER_TRANSFORM,
	// eslint-disable-next-line @atlaskit/ui-styling-standard/no-nested-selectors, @atlaskit/ui-styling-standard/no-unsafe-selectors -- Ignored via go/DSP-18766
	'&&': {
		position: 'absolute',
		width: '24px',
		height: '24px',
	},
});
